/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-11-30, 12:38:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2017-11-30, 14:13:11
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

export default {
  isNonEmpty: {
    check: value => value !== '',
    message: () => 'Pole nie może być puste',
  },

  isNumber: {
    // eslint-disable-next-line no-restricted-globals
    check: value => !isNaN(value),
    message: () => 'Podana wartość musi być liczbą',
  },

  isAlphaNum: {
    check: (value) => {
      let pattern = /[^a-z0-9]/i;
      return !pattern.test(value);
    },
    message: () => 'Pole może nie może zawierać znaków specjalnych',
  },

  isEmail: {
    check: (value) => {
      // eslint-disable-next-line max-len
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value);
    },
    message: () => 'Pole musi zawierać prawidłowy adres email',
  },

  lengthIsGreaterThan: {
    check: (value, length) => value.length >= parseInt(length, 10),
    message: length => `Podana wartość nie może być mniejsza niż ${length}`,
  },

  lengthIsLessThan: {
    check: (value, length) => value.length <= parseInt(length, 10),
    message: length => `Podana wartość nie może być większa niż ${length}`,
  },

  lengthIsEqualTo: {
    check: (value, length) => value.length === parseInt(length, 10),
    message: length => `Podana wartość musi mieć dokładnie ${length} znaków`,
  },

  valueIsLessOrEqualThan: {
    check: (value, assertValue) => parseInt(value, 10) <= parseInt(assertValue, 10),
    message: assertValue => `Podana wartość nie może być większa niż ${assertValue}`,
  },

  isPostalCode: {
    check: (value) => {
      let pattern = /^[0-9]{2}-[0-9]{3}$/;
      return pattern.test(value);
    },
    message: () => 'Pole musi zawierać prawidłowy kod pocztowy',
  },
};
